

export abstract class FileSizeUtil {

    private constructor() { }
    static formatFileSize(bytes: number, decimalPlaces = 2): string {
        if (bytes === 0) {
            return '0 Bytes';
        }

        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

        // Find the appropriate unit index using logarithms
        const i = Math.floor(Math.log(bytes) / Math.log(k));

        // Calculate the size in the new unit
        const formattedSize = (bytes / Math.pow(k, i)).toFixed(decimalPlaces);

        // parseFloat removes trailing zeros
        return `${parseFloat(formattedSize)} ${sizes[i]}`;
    }
}